// extracted by mini-css-extract-plugin
module.exports = {"buttonPaged2":"Paged_buttonPaged2__1Jo3a","button":"Paged_button__1-z48","body":"Paged_body__3Ijac"};